import { Button, Card, Text, VSpacer } from '@/components/DesignSystem';
import { Routes } from '@/constants/Routes';
import { useAuthentication } from '@/contexts/dataSync/AuthenticationContext';
import { ReportType } from '@shared/enums';
import { TierProgressChart } from '@/pages/RetailerOverview/TierProgress/TierProgressChart';
import { ApiRetailer } from '@api/interfaces';
import { ApiRewardsProgram } from '@api/interfaces/ApiRewardsProgram';
import TableChartOutlined from '@mui/icons-material/TableChartOutlined';
import { Divider, Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { agronomyProgramsOnly } from '@/utilities/RewardsProgramUtility';

interface TierProgressCardProps {
  retailer: ApiRetailer,
  selectedProgram: ApiRewardsProgram,
}

export const TierProgressCard = ({
  selectedProgram,
  retailer,
}: TierProgressCardProps) => {
  const { t } = useTranslation();
  const { isInternal } = useAuthentication();
  const navigate = useNavigate();
  const hasMultipleRewardPrograms = agronomyProgramsOnly(retailer?.rewardsPrograms).length > 1;
  return (
    <Card
      cardContentStyle={{ padding: 0 }}
      sx={{ height: '556px', padding: 0, width: '388px' }}
      testID="tier-progress-card"
    >
      <Text fontSize="18px" pt="20px" px="20px">
        {t($ => $.overview.tierProgress.title)}
        {hasMultipleRewardPrograms
          ? ` (${t($ => $.overview.tierProgress.selectedProgramPeriod)})`
          : ''}
      </Text>
      <VSpacer size="4"/>
      <TierProgressChart program={selectedProgram} />
      <VSpacer size="9" />
      <Divider />
      <VSpacer size="5" />
      <Stack alignItems="flex-end" pb="24px" px="20px">
        <Button
          onClick={() => (
            navigate(
              {
                pathname: Routes.REPORT_PAGE.replace(':reportType', ReportType.TierProgress),
                // Internal admins have no retailer of their own, so the report needs it in the URL.
                search: isInternal ? `?retailerId=${retailer.id}` : '',
              },
              { state: { fromOverview: true, selectedProgram } },
            )
          )}
          size="small"
          square
          startIcon={<TableChartOutlined />}
          testID="tier-progress-details-button"
        >
          {t($ => $.common.actions.details)}
        </Button>
      </Stack>
    </Card>
  );
};
